angular.module('property-deal')
    .controller('PropertyDealManagerController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, PropertyDeal) {
        this.$onInit = () => {
            this.item = data;
            this.form = {
                id: this.item.id,
                manager: this.item.manager,
                action: 'manager'
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return PropertyDeal.action(this.form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                toastr.success("Zapisano");
                $uibModalInstance.close(result);
            })
        };
    })
